import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { IItem } from '@coreui/angular-pro'
import { RestService } from 'src/app/services/rest/rest.service';
import { GenericResponse, ServiceTypes, ServiceRequests } from 'src/app/interfaces/apiresponses';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

interface GetDocumentData {
  id: number;
  documentTypeId?: number;
  documentName: string;
  base64Data: string;
}

@Component({
  selector: 'app-support-complaintsUpdateStatus',
  templateUrl: './support-complaintsUpdateStatus.component.html',
  styleUrls: ['./support-complaintsUpdateStatus.component.scss'],
  providers: [DatePipe]
})



export class SupportComplaintsUpdateStatusComponent implements OnInit {
  bUndefined!: boolean
  selectedItem: any
  showUserForm = false;
  selectedUser: any;
  documents: GetDocumentData[] = [];

  // Alert buttons
  bAlert = false
  alertHeaderText = ""
  alertBodyText = ""
  bShowSecondAlertButton = false
  alertSecondButtonText = ""
  alertCloseButtonText = "Close"
  alertBoxData: any

  serviceTypes: any
  date = new Date();
  startDate = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
  endDate = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);

  columns = [
    {
      key: 'dateCreated',
      label: 'Requested On',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'raisedByEmailId',
      label: 'Requested By',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'resolvedOn',
      label: 'Resolved On',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'resolveByEmailId',
      label: 'Resolved By',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'response',
      label: 'Resolution Given',
      _cellProps: { align: 'middle' },
      filter: false
    },
    {
      key: 'isOpen',
      label: 'Status',
      filter: false
    },
    {
      key: 'requestId',
      label: 'Action',
      filter: false
    },
  ];

  serviceData: IItem[] = []
  selectedItems = [2, 3];

  // Resolution Form
  bShowResolution = false
  bValidResolution!: boolean
  resolutionText: string = ''
  resolutionForm = new FormGroup({
    resolutionControl: new FormControl(this.resolutionText, [Validators.required, Validators.minLength(5)])
  })
  userForm!: FormGroup;
  raisedUserId!: string;

  get resolutionControl() { return this.resolutionForm.get('resolutionControl') }

  ifResolutionValid() {
    if (this.resolutionControl?.invalid && (this.resolutionControl?.dirty || this.resolutionControl?.touched)) {
      this.bValidResolution = false
      return 'Enter a valid resolution'
    } else {
      if (this.resolutionControl?.dirty || this.resolutionControl?.touched)
        this.bValidResolution = true
      else
        this.bValidResolution = this.bUndefined
      return ''
    }
  }

  showResolutionModal(item: any) {
    this.selectedItem = item
    this.resolutionControl?.setValue('')
    this.resolutionText = ''
    this.bValidResolution = this.bUndefined
    this.bShowResolution = true
  }

  closeResolutionModal() {
    this.bShowResolution = false
  }

  onStartDateChane(event: any) {
    this.startDate = event
    this.serviceData = []
  }

  onEndDateChane(event: any) {
    this.endDate = event
    this.serviceData = []
  }

  onSelectChange() {
    this.serviceData = []
  }

  constructor(private restApi: RestService, private datePipe: DatePipe, private changeDetector: ChangeDetectorRef, private route: ActivatedRoute) {
    this.serviceData = []

  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  getDateString(dateValue: Date) {
    return this.datePipe.transform(dateValue, "yyyy-MM-dd")
  }

  getDisplayDate(item: any) {
    return this.datePipe.transform(item.dateCreated, "dd-MM-yyyy")
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const complaintId = params['id'];
      // Load complaint details and allow status update
    });

    this.loadServiceTypes()
  }

  loadServiceTypes() {
    this.restApi.getServiceTypesComplaints().subscribe({
      next: (v: ServiceTypes) => {
        if (v.success) {
          this.serviceTypes = v.serviceTypes
        }
      },
      error: (e) => {

      }
    })
  }

  closeAlert(event: any) {

  }

  alertVisibility(event: any) {
    this.bAlert = event.state
  }

  showAlertBox(heading: string, body: string, closeButtonText: string = "Close", showSecondButton: boolean = false, secondButtonText: string = "Understood", data: any = {}) {
    this.alertHeaderText = heading
    this.alertBodyText = body
    this.bShowSecondAlertButton = showSecondButton
    this.alertSecondButtonText = secondButtonText
    this.alertCloseButtonText = closeButtonText
    this.alertBoxData = data
    this.bAlert = true
  }

  onAlertButtonClick(event: any) {
    this.bAlert = event.state
    if (event.data.action === 1) {
    }
  }

  // Search Form
  searchServiceType: string = ''
  searchTicketType: string = ''

  cifSearchForm = new FormGroup({
    searchServiceTypeControl: new FormControl(this.searchServiceType),
    searchTicketTypeControl: new FormControl(this.searchTicketType),
  })

  get searchServiceTypeControl() { return this.cifSearchForm.get('searchServiceTypeControl') }
  get searchTicketTypeControl() { return this.cifSearchForm.get('searchTicketTypeControl') }

  getServices() {
    let showTicketType = 1

    if (this.searchServiceTypeControl?.value == null || this.searchServiceTypeControl?.value == '' || this.searchTicketTypeControl?.value == null || this.searchTicketTypeControl?.value == '') {
      this.showAlertBox('Sorry', 'Please choose the Service Type and Ticket Type before you can search')
      return
    } else {
      if (this.searchTicketTypeControl?.value == 'Open Tickets')
        showTicketType = 1
      else if (this.searchTicketTypeControl?.value == 'Closed Tickets')
        showTicketType = 2
      else
        showTicketType = 3

      let startDateString = this.getDateString(this.startDate)
      let endDateString = this.getDateString(this.endDate)

      if (startDateString != null && endDateString != null) {
        this.restApi.getServiceRequests(this.searchServiceTypeControl?.value, startDateString, endDateString, showTicketType, 2).subscribe({
          next: (v: ServiceRequests) => {
            this.serviceData = v.serviceRequests.map((item, Reference) => {
              const _selected = this.selectedItems.includes(Reference);
              return {
                ...item,
                _selected
              };
            })
          },
          error: (e) => {

          }
        })
      } else {
        this.showAlertBox('Sorry', 'Please correct the dates')
      }
    }
  }

  getStatusBadge(item: any) {
    if (item.isOpen)
      return 'danger'
    else
      return 'success'
  }

  getStatus(item: any) {
    if (item.isOpen)
      return 'Open'
    else
      return 'Resolved'
  }

  showResolveButton(item: any) {
    if (item.isOpen)
      return true
    else
      return false
  }

  getResolutionDate(item: any) {
    if (item.isOpen)
      return ''
    else
      return item.resolvedOn
  }

  processResolution() {
    this.resolutionControl?.markAsTouched()
const internalRemarks = this.userForm.get('internalRemarks')?.value || ''
    if (this.resolutionForm.valid && this.resolutionControl?.value != null) {
      this.restApi.resolveServiceRequest(this.selectedItem.requestId, this.resolutionControl?.value, internalRemarks, "Resolved").subscribe({
        next: (v: GenericResponse) => {
          if (v.success) {
            this.bShowResolution = false
            this.getServices()
          } else {
            this.showAlertBox('Sorry', 'There was a technical issue. Please contact the support')
          }
        },
        error: (e) => {
          this.showAlertBox('Sorry', 'There was a technical issue. Please contact the support')
        }
      })
    } else {
      this.bValidResolution = false
    }
  }

  onRowClick(rowData: any) {
    console.log('Row clicked:', rowData.item.raisedBy);
    if (rowData.item.requestType === "Client Category Update Request") {
      this.raisedUserId = rowData.item.raisedBy;

      this.restApi.getUserFormData(rowData.item.raisedBy).subscribe(
        (userData: any) => {
          if (userData) {

            this.userForm = new FormGroup({
              customerCIF: new FormControl({ value: userData.cif, disabled: true }),
              customerName: new FormControl(userData.fullName || ''),
              customerEmail: new FormControl(userData.email || ''),
              customerMobile: new FormControl(userData.mobile || ''),
              clientCategory: new FormControl(userData.clientCategory || ''),
            });

            this.documents = userData.documents;

            // Show the user form after data is populated
            this.showUserForm = true;
          }
        },
        (error) => {
          console.error('Error fetching user data:', error);
        });
    }
  }

  onUserFormSaveClick() {
    if (this.userForm.valid) {
      const formData = {
        userID: this.raisedUserId,
        fullName: this.userForm.get('customerName')?.value || '',
        email: this.userForm.get('customerEmail')?.value || '',
        mobile: this.userForm.get('customerMobile')?.value || '',
        clientCategory: this.userForm.get('clientCategory')?.value || ''
      };

      this.restApi.postUserFormData(formData).subscribe({
        next: (response) => {
          console.log('User form saved successfully:', response);
          alert('User data saved successfully!');
          this.showUserForm = false;
        },
        error: (error) => {
          console.error('Error saving user data:', error);
        }
      });
    } else {
      alert('Please fill in all required fields.');
    }
  }

  resetForm() {
    this.showUserForm = false;
  }

  downloadDocument(documentData: GetDocumentData) {
    const byteCharacters = atob(documentData.base64Data);
    const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray]);

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = documentData.documentName;
    link.click();
  }
}
